import React from 'react';
import { ClipboardList, Calendar, Scissors } from 'lucide-react';
import { formatDateTime } from './adminConstants';

export function AdminBookingsSection({ bookings }) {
    return (
        <div className="space-y-6" data-testid="admin-bookings">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Bookings Overview</h2>
                <span className="text-muted-foreground">{bookings.length} total bookings</span>
            </div>
            
            <div className="space-y-3">
                {bookings.map(booking => (
                    <div key={booking.id} className="card-base" data-testid={`booking-card-${booking.id}`}>
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                            <div className="flex items-start gap-3">
                                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                                    booking.booking_type === 'appointment' 
                                        ? 'bg-rose-100' 
                                        : 'bg-emerald-100'
                                }`}>
                                    {booking.booking_type === 'appointment' 
                                        ? <Scissors className="w-5 h-5 text-rose-600" />
                                        : <Calendar className="w-5 h-5 text-emerald-600" />
                                    }
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                                        <span className={`text-xs font-bold px-2 py-1 rounded-full ${
                                            booking.status === 'confirmed' ? 'bg-emerald-100 text-emerald-700' :
                                            booking.status === 'waitlist' ? 'bg-amber-100 text-amber-700' :
                                            booking.status === 'cancelled' ? 'bg-red-100 text-red-700' :
                                            'bg-blue-100 text-blue-700'
                                        }`}>
                                            {booking.status}
                                        </span>
                                        <span className={`text-xs px-2 py-1 rounded-full ${
                                            booking.booking_type === 'appointment' 
                                                ? 'bg-rose-50 text-rose-600' 
                                                : 'bg-emerald-50 text-emerald-600'
                                        }`}>
                                            {booking.booking_type === 'appointment' ? 'Service Appointment' : 'Activity'}
                                        </span>
                                    </div>
                                    <p className="font-medium text-stone-800">
                                        {booking.activity?.title || booking.service_type || 'Unknown'}
                                    </p>
                                    <p className="text-sm text-stone-600">
                                        {booking.member?.name || booking.member?.email || 'Unknown Member'}
                                    </p>
                                    {booking.booking_type === 'appointment' && (
                                        <p className="text-sm text-stone-500">
                                            {booking.date} at {booking.time}
                                        </p>
                                    )}
                                    <p className="text-xs text-muted-foreground mt-1">
                                        Booked: {formatDateTime(booking.booked_at)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                
                {bookings.length === 0 && (
                    <div className="card-base text-center py-12">
                        <ClipboardList className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                        <p className="text-muted-foreground">No bookings yet</p>
                    </div>
                )}
            </div>
        </div>
    );
}
